import { render, staticRenderFns } from "./SearchSpeakerRegion.vue?vue&type=template&id=38c307ac&"
import script from "./SearchSpeakerRegion.vue?vue&type=script&lang=js&"
export * from "./SearchSpeakerRegion.vue?vue&type=script&lang=js&"
import style0 from "./SearchSpeakerRegion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports